import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import HistoryEvent from '../HistoryEvent/HistoryEvent'
import * as Styles from './styles'

const HistoryDayGroup = ({ label, events }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      <Styles.DayLabel>
        <Text type="bodySRegular" color={theme.colors.text.subtle}>
          {label}
        </Text>
      </Styles.DayLabel>
      <Styles.EventsList>
        {events.map(event => (
          <HistoryEvent key={event.batchId} event={event} />
        ))}
      </Styles.EventsList>
    </Styles.Container>
  )
}

export default HistoryDayGroup
